import React, { useMemo, useState } from "react";
import ClientViewSelect from "./ClientViewSelect";
import ClientViewMyAppointments from "./ClientViewMyAppointments";
import AppointmentSecondaryTabs from "./AppointmentSecondaryTabs";
import checkPermission from "../../../utils/permission";

export default function ClientTabs() {
  const [activeTab, setActiveTab] = useState<"select" | "my-appointments">("my-appointments");

  const canAdd = checkPermission("appointment_add");
  const canList = checkPermission("appointment_list");

  const visibleTabs = useMemo(
    () =>
      [
        { id: "my-appointments", label: "Randevularım", visible: canList },
        { id: "select", label: "Randevu Seç", visible: canAdd },
      ] as const,
    [canAdd, canList],
  );

  const firstVisible = visibleTabs.find((t) => t.visible)?.id || "select";
  const currentTab = visibleTabs.find((t) => t.id === activeTab && t.visible) ? activeTab : firstVisible;

  const subTabs = visibleTabs.filter((t) => t.visible).map((t) => ({ id: t.id, label: t.label }));

  return (
    <div className="relative mr-0 flex h-full min-h-0 w-full flex-col bg-gray-50 sm:mr-1 sm:rounded-lg sm:shadow-sm">
      <div className="flex-shrink-0 px-3 pt-4 sm:px-6 sm:pt-6">
        <AppointmentSecondaryTabs
          eyebrow="Randevu Al"
          tabs={subTabs}
          activeId={currentTab}
          onChange={(id) => setActiveTab(id as "select" | "my-appointments")}
        />
      </div>
      <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
        {currentTab === "select" ? <ClientViewSelect /> : <ClientViewMyAppointments />}
      </div>
    </div>
  );
}
